﻿const FilePreview = ({ url, isPdf }) => {
  if (!url) {
    return <p className="text-sm text-slate-500">No attachment available.</p>;
  }

  if (isPdf) {
    return (
      <div className="h-[600px] w-full overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        <iframe src={url} title="Document PDF" className="h-full w-full border-none" />
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
      <img
        src={url}
        alt="Document attachment"
        className="max-h-[600px] w-full object-contain mx-auto bg-slate-50"
      />
    </div>
  );
};

const CommonDocumentPreview = ({ document: base64Data }) => {
  if (!base64Data) {
    return (
      <p className="text-sm text-slate-500 py-4 text-center">No document content available.</p>
    );
  }

  const isPdf = base64Data.startsWith('JVBERi0');
  const mimeType = isPdf ? 'application/pdf' : 'image/png';
  const dataUri = `data:${mimeType};base64,${base64Data}${isPdf ? '#toolbar=0' : ''}`;

  return (
    <div
      className="space-y-4 select-none animate-in fade-in duration-300"
      onContextMenu={(e) => e.preventDefault()}
    >
      <FilePreview url={dataUri} isPdf={isPdf} />
    </div>
  );
};

export default CommonDocumentPreview;
